// extracted by mini-css-extract-plugin
export var section_wrapper = "contact-section-module--section_wrapper--1UKb6";
export var effect_up = "contact-section-module--effect_up--1Hs4l";
export var effect_down = "contact-section-module--effect_down--wbKiI";
export var content = "contact-section-module--content--39-O4";
export var before_form = "contact-section-module--before_form--3Hvxb";
export var subtitle = "contact-section-module--subtitle--N8MC3";
export var separator = "contact-section-module--separator--2mS9p";
export var before_title = "contact-section-module--before_title--2Firr";
export var form_wrapper = "contact-section-module--form_wrapper--uBowb";